import React from 'react';
import DataTable from './components/DataTable';
import DrawerLeft from './components/Drawer';
import './App.css';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from 'react-router-dom';
import { resources } from './configs/resources';
import { resourcesNavigationGroups } from './configs/app.config';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LoginForm from './components/LoginForm';
import { Box } from '@mui/system';
import PrivateRoute, { authenticate } from './components/PrivateRoute';
import NotFound from './components/NotFound';
import PopUpAlert, { useAlert } from './components/PopUpAlert';

const determineTheme = () => {
  if (!localStorage.theme) localStorage.setItem('theme', 'dark');
  return localStorage.theme;
};

function App() {
  const [theme, setTheme] = React.useState(determineTheme());
  const [auth, setAuth] = React.useState(authenticate());
  const darkTheme = createTheme({
    palette: {
      mode: theme,
      neutral: {
        main: '#FF8325',
        dark: '#FF8325',
        light: '#FF8325',
        contrastText: '#fff',
      },
      primary: {
        // light: will be calculated from palette.primary.main,
        main: '#FF8325',
        dark: '#FF8325',
        // dark: will be calculated from palette.primary.main,
        // contrastText: will be calculated to contrast with palette.primary.main
      },
      secondary: {
        light: '#0066ff',
        main: '#0044ff',
        // dark: will be calculated from palette.secondary.main,
        contrastText: '#ffcc00',
      },
      // Used by `getContrastText()` to maximize the contrast between
      // the background and the text.
      contrastThreshold: 3,
      // Used by the functions below to shift a color's luminance by approximately
      // two indexes within its tonal palette.
      // E.g., shift from Red 500 to Red 300 or Red 700.
      tonalOffset: 0.2,
    }
  });
  const [alert, setAlert] = useAlert();

  return (
    <Router>
      <ThemeProvider theme={darkTheme}>
        <Box className='App' style={{ display: 'flex' }}>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <PopUpAlert alert={alert} setAlert={setAlert} />
            {auth.isAuthenticated && (
              <DrawerLeft
                resourcesNavigationGroups={resourcesNavigationGroups}
                resources={resources}
                auth={auth}
                setAuth={setAuth}
                setTheme={setTheme}
              />
            )}
            <Switch>
              <PrivateRoute
                path='/'
                exact
                useAuth={[auth, setAuth]}
                component={() => <Redirect to='/client' />}
              />
              <Route
                path='/login'
                exact
                component={() => <LoginForm setAuth={setAuth} auth={auth} />}
              />
              {Object.values(resources).map((resource) => (
                <PrivateRoute
                  path={`/${resource.name}`}
                  exact
                  key={resource.name}
                  useAuth={[auth, setAuth]}
                  component={() => (
                    <DataTable
                      resource={resource}
                      auth={auth}
                      setAlert={setAlert}
                    />
                  )}
                />
              ))}
              <Route component={NotFound} />
            </Switch>
          </LocalizationProvider>
        </Box>
      </ThemeProvider>
    </Router>
  );
}

export default App;
